import "../../css/blocks/icon-links-grid.css";
import { editorIntegration } from "../modules/editor-integration";

function initIconLinksGrid(): void {
  const iconLinksGridBlocks = document.querySelectorAll(".icon-links-grid");

  if (iconLinksGridBlocks.length) {
    // Initialize block-specific functionality here
    // Currently no interactive functionality, but ready for future enhancements
  }
}

// Register with editor integration for consistent initialization
editorIntegration.register("icon-links-grid", initIconLinksGrid);